import '.bx{position:absolute;}.ssr-plugin'
import '.m2{right:0.25rem;}.ssr-plugin'
import '.m3{bottom:0.25rem;}.ssr-plugin'
import '.c9{z-index:2;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.s{flex-direction:row;}.ssr-plugin'
import '.aj{flex-wrap:wrap;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.bt{justify-content:flex-end;}.ssr-plugin'
import '.m4{gap:0.125rem;}.ssr-plugin'
import '.b0{max-width:100%;}.ssr-plugin'
import '.m5{pointer-events:auto;}.ssr-plugin'
import '.ab{position:relative;}.ssr-plugin'
import '.ca{display:inline-flex;}.ssr-plugin'
import '.bh{right:0px;}.ssr-plugin'
import '.m6{bottom:calc(100% + 0.25rem);}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.e2{gap:0.375rem;}.ssr-plugin'
import '.m7{padding:0.375rem;}.ssr-plugin'
import '.fg{border-radius:0.5rem;}.ssr-plugin'
import '.i3{border:1px solid var(--gray-200);}.ssr-plugin'
import '.do{background:var(--palette-white);}.ssr-plugin'
import '.m8{box-shadow:0 2px 8px rgba(0, 0, 0, 0.12);}.ssr-plugin'
import '.m9{z-index:3;}.ssr-plugin'
import '.ma{min-width:14rem;}.ssr-plugin'
import '.e6{gap:0.25rem;}.ssr-plugin'
import '.at{flex:1;}.ssr-plugin'
import '.a4{min-width:0px;}.ssr-plugin'
import '.hn{border-radius:0.375rem;}.ssr-plugin'
import '.ff{padding:0.25rem 0.5rem;}.ssr-plugin'
import '.ay{font-size:0.875rem;}.ssr-plugin'
import '.mb{font-family:inherit;}.ssr-plugin'
import '.cq{outline:none;}.ssr-plugin'
import '.e7{color:var(--brand-primary);}.ssr-plugin'
import '.e8{font-size:0.75rem;}.ssr-plugin'
import '.e5{white-space:nowrap;}.ssr-plugin'
import '.mc{color:var(--gray-900);}.ssr-plugin'
import '.md{color:var(--status-error);}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.ej{color:var(--gray-700);}.ssr-plugin'
import '.dd{user-select:none;}.ssr-plugin'
import '.if{margin:0px;}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { $insertList, $removeList, $isListNode } from '@lexical/list'
import { $isLinkNode, TOGGLE_LINK_COMMAND } from '@lexical/link'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import {
  faBold,
  faItalic,
  faLink,
  faListOl,
  faListUl,
  faStrikethrough,
} from '@fortawesome/pro-regular-svg-icons'
import {
  COMMAND_PRIORITY_LOW,
  FORMAT_TEXT_COMMAND,
  SELECTION_CHANGE_COMMAND,
  $getSelection,
  $isRangeSelection,
  type TextFormatType,
} from 'lexical'
import { mergeRegister } from '@lexical/utils'
import {
  type KeyboardEvent,
  type MouseEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import { type Style, styled } from 'inlines'

export type ToolbarFormatState = {
  bold: boolean
  italic: boolean
  strikethrough: boolean
  bulletList: boolean
  numberList: boolean
  isLink: boolean
}

const defaultFormatState: ToolbarFormatState = {
  bold: false,
  italic: false,
  strikethrough: false,
  bulletList: false,
  numberList: false,
  isLink: false,
}

const readToolbarFormatState = (): ToolbarFormatState => {
  const selection = $getSelection()
  if (!$isRangeSelection(selection)) {
    return defaultFormatState
  }

  let bulletList = false
  let numberList = false
  let isLink = false
  let node = selection.anchor.getNode()
  while (node) {
    if ($isListNode(node)) {
      const listType = node.getListType()
      bulletList = listType === 'bullet'
      numberList = listType === 'number'
    }
    if ($isLinkNode(node)) {
      isLink = true
    }
    const parent = node.getParent()
    if (!parent) {
      break
    }
    node = parent
  }

  return {
    bold: selection.hasFormat('bold'),
    italic: selection.hasFormat('italic'),
    strikethrough: selection.hasFormat('strikethrough'),
    bulletList,
    numberList,
    isLink,
  }
}

const readLinkUrl = (): string => {
  const selection = $getSelection()
  if (!$isRangeSelection(selection)) {
    return ''
  }

  let node = selection.anchor.getNode()
  while (node) {
    if ($isLinkNode(node)) {
      return node.getURL()
    }
    const parent = node.getParent()
    if (!parent) {
      break
    }
    node = parent
  }

  return ''
}

const readLinkNewTab = (): boolean => {
  const selection = $getSelection()
  if (!$isRangeSelection(selection)) {
    return false
  }

  let node = selection.anchor.getNode()
  while (node) {
    if ($isLinkNode(node)) {
      return node.getTarget() === '_blank'
    }
    const parent = node.getParent()
    if (!parent) {
      break
    }
    node = parent
  }

  return false
}

const sanitizeLinkUrl = (url: string): string | null => {
  const trimmed = url.trim()
  if (!trimmed) {
    return null
  }
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('/')
  ) {
    return trimmed
  }
  return null
}

const iconToolbarButtonBase: Style = {
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  padding: '0.35rem',
  borderRadius: '0.375rem',
  color: 'var(--gray-900)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 0,
  '&:hover': {
    background: 'var(--gray-100)',
  },
  '&:disabled': {
    opacity: 0.35,
    cursor: 'not-allowed',
  },
}

type LexicalRichHtmlInputToolbarProps = {
  enableLinks?: boolean
}

export const LexicalRichHtmlInputToolbar = ({
  enableLinks,
}: LexicalRichHtmlInputToolbarProps) => {
  const [editor] = useLexicalComposerContext()
  const t = useTranslations().app.dashboard.pageContentEditor
  const [formats, setFormats] = useState<ToolbarFormatState>(defaultFormatState)
  const [showLinkInput, setShowLinkInput] = useState(false)
  const [linkUrl, setLinkUrl] = useState('')
  const [linkNewTab, setLinkNewTab] = useState(false)
  const linkInputRef = useRef<HTMLInputElement>(null)

  const refreshFormats = useCallback(() => {
    editor.getEditorState().read(() => {
      setFormats(readToolbarFormatState())
    })
  }, [editor])

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        SELECTION_CHANGE_COMMAND,
        () => {
          refreshFormats()
          return false
        },
        COMMAND_PRIORITY_LOW,
      ),
      editor.registerUpdateListener(() => {
        refreshFormats()
      }),
    )
  }, [editor, refreshFormats])

  useEffect(() => {
    if (!showLinkInput) {
      return
    }
    linkInputRef.current?.focus()
    linkInputRef.current?.select()
  }, [showLinkInput])

  const dispatchFormat = useCallback(
    (format: TextFormatType) => {
      void editor.dispatchCommand(FORMAT_TEXT_COMMAND, format)
    },
    [editor],
  )

  const closeLinkInput = useCallback(() => {
    setShowLinkInput(false)
    setLinkUrl('')
    setLinkNewTab(false)
  }, [])

  const openLinkInput = useCallback(() => {
    editor.getEditorState().read(() => {
      setLinkUrl(readLinkUrl())
      setLinkNewTab(readLinkNewTab())
    })
    setShowLinkInput(true)
  }, [editor])

  const confirmLink = useCallback(() => {
    const sanitized = sanitizeLinkUrl(linkUrl)
    if (!sanitized) {
      return
    }

    void editor.dispatchCommand(TOGGLE_LINK_COMMAND, {
      url: sanitized,
      target: linkNewTab ? '_blank' : '_self',
      rel: linkNewTab ? 'noopener noreferrer' : null,
    })
    closeLinkInput()
  }, [editor, linkUrl, linkNewTab, closeLinkInput])

  const removeLink = useCallback(() => {
    void editor.dispatchCommand(TOGGLE_LINK_COMMAND, null)
    closeLinkInput()
  }, [editor, closeLinkInput])

  const handleLinkButtonClick = useCallback(() => {
    openLinkInput()
  }, [openLinkInput])

  const handleLinkInputKeyDown = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        confirmLink()
      } else if (e.key === 'Escape') {
        e.preventDefault()
        closeLinkInput()
      }
    },
    [confirmLink, closeLinkInput],
  )

  const activeTint: Style = {
    color: 'var(--brand-primary)',
    background: 'var(--palette-blue-50)',
  }

  return (
    <div className="bx m2 m3 c9 a s aj t bt m4 b0 m5"
      onMouseDown={(e: MouseEvent) => {
        e.preventDefault()
      }}
    >
      <styled.button
        type="button"
        aria-label={t.richTextBold}
        style={{
          ...iconToolbarButtonBase,
          ...(formats.bold ? activeTint : {}),
        }}
        onClick={() => dispatchFormat('bold')}
      >
        <FontAwesomeIcon
          icon={faBold}
          style={{ width: '1rem', height: '1rem' }}
        />
      </styled.button>
      <styled.button
        type="button"
        aria-label={t.richTextItalic}
        style={{
          ...iconToolbarButtonBase,
          ...(formats.italic ? activeTint : {}),
        }}
        onClick={() => dispatchFormat('italic')}
      >
        <FontAwesomeIcon
          icon={faItalic}
          style={{ width: '1rem', height: '1rem' }}
        />
      </styled.button>
      <styled.button
        type="button"
        aria-label={t.richTextStrikethrough}
        style={{
          ...iconToolbarButtonBase,
          ...(formats.strikethrough ? activeTint : {}),
        }}
        onClick={() => dispatchFormat('strikethrough')}
      >
        <FontAwesomeIcon
          icon={faStrikethrough}
          style={{ width: '1rem', height: '1rem' }}
        />
      </styled.button>
      <styled.button
        type="button"
        aria-label={t.richTextBulletList}
        style={{
          ...iconToolbarButtonBase,
          ...(formats.bulletList ? activeTint : {}),
        }}
        onClick={() => {
          editor.update(() => {
            const f = readToolbarFormatState()
            if (f.bulletList) {
              $removeList()
              return
            }
            if (f.numberList) {
              $removeList()
            }
            $insertList('bullet')
          })
        }}
      >
        <FontAwesomeIcon
          icon={faListUl}
          style={{ width: '1rem', height: '1rem' }}
        />
      </styled.button>
      <styled.button
        type="button"
        aria-label={t.richTextNumberedList}
        style={{
          ...iconToolbarButtonBase,
          ...(formats.numberList ? activeTint : {}),
        }}
        onClick={() => {
          editor.update(() => {
            const f = readToolbarFormatState()
            if (f.numberList) {
              $removeList()
              return
            }
            if (f.bulletList) {
              $removeList()
            }
            $insertList('number')
          })
        }}
      >
        <FontAwesomeIcon
          icon={faListOl}
          style={{ width: '1rem', height: '1rem' }}
        />
      </styled.button>
      {enableLinks ? (
        <div className="ab ca"
        >
          <styled.button
            type="button"
            aria-label={t.richTextLink}
            style={{
              ...iconToolbarButtonBase,
              ...(formats.isLink ? activeTint : {}),
            }}
            onClick={handleLinkButtonClick}
          >
            <FontAwesomeIcon
              icon={faLink}
              style={{ width: '1rem', height: '1rem' }}
            />
          </styled.button>
          {showLinkInput ? (
            <div className="bx bh m6 a b e2 m7 fg i3 do m8 m9 ma"
              onMouseDown={(e: MouseEvent) => e.stopPropagation()}
            >
              <div className="a s t e6"
              >
                <styled.input className="at a4 i3 hn ff ay mb cq"
                  ref={linkInputRef}
                  type="url"
                  value={linkUrl}
                  placeholder={t.richTextLinkUrlPlaceholder}
                  aria-label={t.richTextLinkUrlPlaceholder}
                  style={{
                    '&:focus': {
                      borderColor: 'var(--palette-blue-300)',
                    },
                  }}
                  onChange={(e) => setLinkUrl(e.target.value)}
                  onKeyDown={handleLinkInputKeyDown}
                />
                <styled.button className="e7 e8 ff e5"
                  type="button"
                  aria-label={t.richTextLinkConfirm}
                  style={{
                    ...iconToolbarButtonBase,}}
                  onClick={confirmLink}
                  disabled={!sanitizeLinkUrl(linkUrl)}
                >
                  {t.richTextLinkConfirm}
                </styled.button>
                <styled.button className="mc e8 ff e5"
                  type="button"
                  aria-label={t.richTextLinkCancel}
                  style={{
                    ...iconToolbarButtonBase,}}
                  onClick={closeLinkInput}
                >
                  {t.richTextLinkCancel}
                </styled.button>
                {formats.isLink ? (
                  <styled.button className="md e8 ff e5"
                    type="button"
                    aria-label={t.richTextLinkRemove}
                    style={{
                      ...iconToolbarButtonBase,}}
                    onClick={removeLink}
                  >
                    {t.richTextLinkRemove}
                  </styled.button>
                ) : null}
              </div>
              <label className="a s t e2 a1 e8 ej dd"
              >
                <input className="if a1"
                  type="checkbox"
                  checked={linkNewTab}
                  onChange={(e) => setLinkNewTab(e.target.checked)}
                />
                {t.richTextLinkNewTab}
              </label>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
